<template>
    <div class="digital-classrooms-event__table-cell digital-classrooms-event__sign-up-button">
        <template v-if="hasAccessToSignup">
            <template v-if="event.trainingStatus === 'confirmed'">
                <template v-if="eventIsNotFull || isUserSignedToEvent">
                    <TotemButton
                        v-if="!isUserSignedToEvent && !isSignUpClosedForEvent"
                        @click="signUpForDigitalClassRoom(event)"
                        :color="getSignUpButtonColor"
                        :size="getSignupButtonSize"
                        :fullWidth="true"
                        class="digital-classrooms-event__button"
                        :disabled="isProcessingSignUp"
                    >
                        <span>{{ getSignUpButtonText }}</span>
                        <span v-if="isProcessingSignUp && isDesktopView" class="spinner icon-spinner digital-classrooms-event__button-spinner"></span>
                    </TotemButton>
                    <TotemButton
                        v-else-if="!hasEventStarted && isUserSignedToEvent"
                        @click="cancelSignUpForDigitalClassRoom(event)"
                        color="secondary"
                        :size="getSignupButtonSize"
                        :fullWidth="true"
                        :disabled="isProcessingSignUp"
                        class="digital-classrooms-event__button"
                    >
                        <span>{{ getCancelSignUpButtonText }}</span>
                        <span v-if="isProcessingSignUp && isDesktopView" class="spinner icon-spinner digital-classrooms-event__button-spinner"></span>
                    </TotemButton>
                </template>
                <template v-else-if="!isSignUpClosedForEvent">
                    <TotemButton
                        color="dark"
                        :size="getSignupButtonSize"
                        :fullWidth="true"
                        :disabled="true"
                        class="digital-classrooms-event__button"
                    >
                        <span>{{ $t('DigitalClassrooms.event_full') }}</span>
                    </TotemButton>
                </template>
            </template>
            <template v-if="isSignUpClosedForEvent && !isUserSignedToEvent">
                <TotemButton
                    color="dark"
                    :size="getSignupButtonSize"
                    :fullWidth="true"
                    :disabled="true"
                    class="digital-classrooms-event__button"
                >
                    <span>{{ $t('DigitalClassrooms.signup_closed') }}</span>
                </TotemButton>
            </template>
            <template v-if="isUserSignedToEvent && isSignUpClosedForEvent && !hasEventEnded && hasTeamsUrl">
                <TotemTeamsButton
                    :fullWidth="true"
                    :meetingUrl="event.classroomUrl"
                    class="digital-classrooms-event__button"
                >
                </TotemTeamsButton>
            </template>
        </template>
        <template v-if="userHasNoAccessButHasSignedUp">
            <div class="digital-classrooms-event__table-cell">
                <TotemButton
                    v-if="!hasEventStarted && isUserSignedToEvent"
                    @click="cancelSignUpForDigitalClassRoom(event)"
                    color="secondary"
                    :size="getSignupButtonSize"
                    :fullWidth="true"
                    :disabled="isProcessingSignUp"
                    class="digital-classrooms-event__button"
                >
                    <span>{{ getCancelSignUpButtonText }}</span>
                    <span v-if="isProcessingSignUp && isDesktopView" class="spinner icon-spinner digital-classrooms-event__button-spinner"></span>
                </TotemButton>
                <TotemButton
                    v-else
                    color="primary"
                    :size="getSignupButtonSize"
                    :fullWidth="true"
                    :disabled="true"
                    class="digital-classrooms-event__button"
                >
                    <span>{{ $t('DigitalClassrooms.sign_up_button') }}</span>
                </TotemButton>
            </div>
        </template>
        <template v-else-if="hasEventEnded">
            <CourseTest
                :title = course.title
                :courseId="course.id"
                :hasTest="course.isTestAvailable"
                :isDemo="course.demo"
                :isDigitalClassRoomTraining="true"
                :showDescriptionText="false"
                :noBackGround="true"
                :noMargins="true"
                size="small"
            />
        </template>
    </div>
</template>

<script>
    import digitalClassRoomHelper from 'components/shared/mixins/digitalClassRoomHelper'
    import CourseTest from 'components/coursepage/courseaddons/CourseTest'
    import { mapGetters } from 'vuex'

    export default {
        name: 'DigitalClassRoomSignupButton',
        components: { CourseTest },
        mixins: [ digitalClassRoomHelper ],
        data () {
            return {
                isProcessingSignUp: false,
            }
        },
        props: {
            isPastEvent: {
                type: Boolean,
                default: false,
            },
            hasAccessToSignup: {
                type: Boolean,
                default: false,
            },
            event: Object,
            course: Object
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                signedUpEvents: 'Courses/getSignedUpEventsForUser'
            }),
            getSignUpButtonColor () {
                return this.isProgressingSignUp ? 'secondary' : 'primary'
            },
            getCancelSignUpButtonText () {
                return this.isProcessingSignUp ? this.$t('DigitalClassrooms.sign_up_cancel_processing_button')
                    : this.$t('DigitalClassrooms.cancel_sign_up_button')
            },
            getSignUpButtonText () {
                return this.isProcessingSignUp ? this.$t('DigitalClassrooms.sign_up_processing_button')
                    : this.$t('DigitalClassrooms.sign_up_button')
            },
            getSignupButtonSize () {
                return this.isDesktopView ? 'medium' : 'small'
            }
        },
        methods: {
            async onSignUpAccepted () {
                this.$modal.hide('dialog')
                this.$emit('setProcessingSignUpState', true)
                this.isProcessingSignUp = true
                this.$emit('showErrorMessage', null)
                try {
                    await this.$store.dispatch('Courses/signUpForDigitalClassRoom', { courseId: this.course.id, eventId: this.event.id })
                    this.$emit('showPopupMessage', this.$t('DigitalClassrooms.signed_up_message'))
                } catch (error) {
                    this.$emit('showErrorMessage', error.code)
                } finally {
                    this.isProcessingSignUp = false
                    this.$emit('setProcessingSignUpState', false)
                    await this.$store.dispatch('Courses/loadDigitalClassRoomSignUpsForCourse', this.course.id)
                }
            },
            async onSignUpCancelAccepted () {
                this.$modal.hide('dialog')
                this.$emit('setProcessingSignUpState', true)
                this.isProcessingSignUp = true
                this.$emit('showErrorMessage', null)
                try {
                    await this.$store.dispatch('Courses/cancelSignUpForDigitalClassRoom', { courseId: this.course.id, eventId: this.event.id, subscriptionId: this.getSubscriptionId() })
                    this.$emit('showPopupMessage', this.$t('DigitalClassrooms.signed_up_cancel_message'))
                } catch (error) {
                    this.$emit('showErrorMessage', error.code)
                } finally {
                    this.isProcessingSignUp = false
                    this.$emit('setProcessingSignUpState', false)
                    await this.$store.dispatch('Courses/loadDigitalClassRoomSignUpsForCourse', this.course.id)
                }
            },
            getSubscriptionId () {
                const subscriptionId = this.signedUpEvents.find(event => event.training.id === this.event.id).id
                return subscriptionId
            }
        }
    }
</script>

<style lang="scss" scoped>
    @include digital-classrooms-event;
    @include digital-classrooms-table;

</style>
